module.exports = __webpack_public_path__ + "static/img/mfqBg.a5eae09.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/mfqBg.png
// module id = A8ob
// module chunks = 1